import {Component} from 'vue-property-decorator';
import SelectDialogMixin from '@/components/dialog/SelectDialogMixin';
import {CaseInfoProductListInfo} from '@/model/CommonModel';

@Component
export default class ProductSelectDialogMixin extends SelectDialogMixin {
    protected readonly menuId: string = 'MU-CI-PD';
    protected values: CaseInfoProductListInfo[] = [];
    
    get getValues() {
        return this.values;
    }
    
    get productColumns() {
        return this.$store.getters.isSponsorType
            ?
            [
                {
                    columnId: 'BRAND_NAME',
                    columnLabel: this.$root.$t('message.case.product.brandName').toString(),
                    filtered: 'N',
                    visible: 'Y'
                },
                {
                    columnId: 'PRD_NAME',
                    columnLabel: this.$root.$t('message.case.product.ipName').toString(),
                    filtered: 'N',
                    visible: 'Y'
                }
            ]
            :
            [
                {
                    columnId: 'BRAND_NAME',
                    columnLabel: this.$root.$t('message.case.product.brandName').toString(),
                    filtered: 'N',
                    visible: 'Y'
                },
                {
                    columnId: 'PRD_NAME',
                    columnLabel: this.$root.$t('message.case.product.ipName').toString(),
                    filtered: 'N',
                    visible: 'Y'
                },
                {
                    columnId: 'SND_ORGAN',
                    columnLabel: this.$root.$t('message.case.product.sender').toString(),
                    filtered: 'N',
                    visible: 'Y'
                }
            ];
        
    }
}
